var globalFunctions = require('./globalFunctions.js');

module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>H -0.5</li> '+
                            '<li>H +0.5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>H -1.5</li> '+
                            '<li>H +1.5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>H -2.5</li> '+
                            '<li>H +2.5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>H -3.5</li> '+
                            '<li>H +3.5</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="H -0.5" data-betCode="704" class="bet-choose" data-odd="'+quotes.HomeUnder05+'">'+globalFunctions.checkQuotes(quotes.HomeUnder05)+'</li> '+
                                '<li data-betType="H +0.5" data-betCode="706" class="bet-choose" data-odd="'+quotes.HomeOver05+'">'+globalFunctions.checkQuotes(quotes.HomeOver05)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="H -1.5" data-betCode="714" class="bet-choose" data-odd="'+quotes.HomeUnder15+'">'+globalFunctions.checkQuotes(quotes.HomeUnder15)+'</li> '+
                                '<li data-betType="H +1.5" data-betCode="716" class="bet-choose" data-odd="'+quotes.HomeOver15+'">'+globalFunctions.checkQuotes(quotes.HomeOver15)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="H -2.5" data-betCode="724" class="bet-choose" data-odd="'+quotes.HomeUnder25+'">'+globalFunctions.checkQuotes(quotes.HomeUnder25)+'</li> '+
                                '<li data-betType="H +2.5" data-betCode="726" class="bet-choose" data-odd="'+quotes.HomeOver25+'">'+globalFunctions.checkQuotes(quotes.HomeOver25)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="H -3.5" data-betCode="734" class="bet-choose" data-odd="'+quotes.HomeUnder35+'">'+globalFunctions.checkQuotes(quotes.HomeUnder35)+'</li> '+
                                '<li data-betType="H +3.5" data-betCode="736" class="bet-choose" data-odd="'+quotes.HomeOver35+'">'+globalFunctions.checkQuotes(quotes.HomeOver35)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/home_under_over.js
// module id = 2014
// module chunks = 4